export const environment = {
  production: true,
  logErrors: true,
  clientUrl: 'https://visbos.tech',
  baseUrl: 'https://visbos.tech:8081',
  logUrl: '',
  graphqlUrl: '',
  exportUrl: '',
  pusherAuthServer: '',
  authServer: '',
  storage: '',
  passwordEMailUrl: '',
  passwordResetUrl: '',

  network: {
    forceFetch: false
  },

  view: {
    show_parents: true,
    ubd_range_in_days: 30
  },

  selection: {
    country_id: "citwjjcxk0001m4t9zq2xixun",
    packing_unit_id: "citwjn2nx0001m4t9sdvim6gc"
  },

  rfid: {
    marry_reader_cuid: "ck42unica00015xr92pg6j7yq"
  },

  touch: {
    timeout: 1800,
    commit_interval: 300
  },

  pusher: {
    key: 'da14405f079e4cdf154f',
    host: 'pusher.visbos.com',
    wsPort: 443,
    wssPort: 443,
    encrypted: true,
    wsPath: ''
  }

};

environment.graphqlUrl = environment.baseUrl + '/api/graphql';
environment.authServer = environment.baseUrl + '/api/authentication';
environment.pusherAuthServer = environment.baseUrl + '/broadcasting/auth';
environment.storage = environment.baseUrl + '/api/storage';
environment.passwordEMailUrl = environment.baseUrl + '/api/password/email';
environment.passwordResetUrl = environment.baseUrl + '/api/password/reset';
environment.logUrl = environment.baseUrl + '/api/log/';
environment.exportUrl = environment.baseUrl + '/api/exports/';



// WEBPACK FOOTER //
// ./src/environments/environment.ts